import { render, staticRenderFns } from "./Revocacion.vue?vue&type=template&id=1c7888dc"
import script from "./Revocacion.vue?vue&type=script&lang=js"
export * from "./Revocacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7888dc')) {
      api.createRecord('1c7888dc', component.options)
    } else {
      api.reload('1c7888dc', component.options)
    }
    module.hot.accept("./Revocacion.vue?vue&type=template&id=1c7888dc", function () {
      api.rerender('1c7888dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/Revocacion.vue"
export default component.exports